<script>
    import MultiSelect from "vue-multiselect"
    import FormDropdown from '../../components/forms/FormDropdown.vue'
    import FormInput from '../../components/forms/FormInput.vue'
    import FormPhoneInput from '../../components/forms/FormPhoneInput.vue'
    import NumberInput from "../auth/intakeForm/NumberInput.vue"
    import axios from 'axios'
    import { Inertia } from '@inertiajs/inertia';

  	export default {
        components: { MultiSelect, FormInput, FormPhoneInput, FormDropdown, NumberInput },
		props: {
			formData: Object,
            errors: Object,
            userDetails: Object,
            timeZoneList: Array,
            hasOtp: Object
		},
        data() {
            return {
                email: null,
                emailError: null,
                newPhoneEmail: null
            }
        },
        methods: {
            timezoneOptionLabel(option) {
                return `${option.text}`
            },
            selectTimezone(value) {
                console.log(value.text)
                return true
            },
            removeSelectedTimezone(value) {
                return true
            },
            verifyPhoneOrEmail(type) {
                let alreadyHasOtp = type === 'email' ? this.hasOtp.emailVerifyHasOtp : this.hasOtp.phoneVerifyHasOtp;
                let alreadyHasOtpBtn = '';
                if (alreadyHasOtp) {
                    alreadyHasOtpBtn = '<button type="button" class="btn btn-link" id="already_have_otp" style="margin-top: -30px;">Already have an OTP?</button>'
                }
                this.$swal({
                    title: `${type === 'email' ? 'Verify Email' : 'Verify Phone'}`,
                    html: `<div class="form-group">
                                <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                    ${type === 'phone' ? `<div class="input-group-prepend">
                                        <span class="input-group-text swal2-input">+1</span>
                                    </div>` : ''}
                                    <input type="text" class="form-control swal2-input swal2-input-for-country" value="${type === 'email' ? this.userDetails.email : this.userDetails.phone}" readonly>
                                </div>
                            </div>${alreadyHasOtpBtn}`,
                    showCancelButton: true,
                    confirmButtonText: 'Send OTP',
                    confirmButtonColor: 'rgb(20, 155, 177)',
                    showLoaderOnConfirm: () => !this.$swal.isLoading(),
                    preConfirm: () => {
                        return new Promise((resolve) => {
                            const content = {
                                email: {
                                    route: route('email-verify-send-otp')
                                },
                                phone: {
                                    route: route('send-otp')
                                }
                            }
                            axios.get(content[type].route, {})
                            .then(response => {
                                Inertia.reload()
                                resolve(response.data);
                            })
                            .catch(err => {
                                this.$swal.showValidationMessage('Something went wrong!');
                                this.$swal.hideLoading();
                            })
                        });
                    },
                    allowOutsideClick: () => !this.$swal.isLoading(),
                    didOpen: () => {
                        if (alreadyHasOtpBtn) {
                            const button = document.querySelector('#already_have_otp');
                            button.addEventListener('click', () => this.submitOtpPhoneOrEmail(type, 'verify'));
                        }
                    },
                    willClose: () => {
                        if (alreadyHasOtpBtn) {
                            const button = document.querySelector('#already_have_otp');
                            button.removeEventListener('click', () => this.submitOtpPhoneOrEmail(type, 'verify'));
                        }
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.submitOtpPhoneOrEmail(type, 'verify', result.value.message);
                    }
                });
            },
            changePhoneOrEmail(type) {
                let new_phone_email = '';
                const title = type === 'email' ? (this.userDetails.email == null ? 'Add Email' : 'Change Email') : (this.userDetails.phone == null ? 'Add Phone Number' : 'Change Phone Number')
                const confirmButtonText = type === 'email' ? 'Send OTP' : (this.userDetails.phone == null ? 'Add' : 'Change')
                this.$swal({
                    title: title,
                    html: `<div class="form-group">
                                <label style='margin: 10px 0;'>${type === 'email' ? 'Enter the new Email ID' : 'Enter the Phone Number'}</label>
                                <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                    ${type === 'phone' ? `<div class="input-group-prepend">
                                        <span class="input-group-text swal2-input">+1</span>
                                    </div>` : ''}
                                    <input type="text" id='change_phone_email_field' class="form-control swal2-input swal2-input-for-country" placeholder="${type === 'email' ? 'Enter the Email' : 'Enter the Phone Number'}">
                                </div>
                            </div>`,
                    showCancelButton: true,
                    confirmButtonText: confirmButtonText,
                    confirmButtonColor: 'rgb(20, 155, 177)',
                    showLoaderOnConfirm: () => !this.$swal.isLoading(),
                    preConfirm: () => {
                        return new Promise((resolve) => {
                            new_phone_email = $("#change_phone_email_field").val().trim();
                            this.newPhoneEmail = new_phone_email;
                            let error = false;
                            if (type === 'email') {
                                if (!new_phone_email) {
                                    this.$swal.showValidationMessage("Please enter a valid Email.")
                                    error = true;
                                }
                                else if(this.userDetails.email == new_phone_email) {
                                    this.$swal.showValidationMessage("Please enter a different E-Mail ID.");
                                    error = true;
                                }
                            } else {
                                if (!new_phone_email) {
                                    this.$swal.showValidationMessage("Please enter a valid Phone Number.")
                                    error = true;
                                }
                                else if(this.userDetails.phone == new_phone_email) {
                                    this.$swal.showValidationMessage("Please enter a different Phone Number.");
                                    error = true;
                                }
                                else if(new_phone_email.length != 14 || !new_phone_email.match(/^[(][\d]{3}[)][\s]{1}[\d]{3}[-][\d]{4}$/)) {
                                    this.$swal.showValidationMessage("Please enter a valid Phone Number.");
                                    error = true;
                                }
                            }
                            if (!error) {
                                const content = {
                                    email: {
                                        route: route('check_email_existence'),
                                        value: { email: new_phone_email }
                                    },
                                    phone: {
                                        route: route('check_phone_existence'),
                                        value: { phone: new_phone_email }
                                    }
                                }
                                axios.post(content[type].route, content[type].value, {})
                                .then(response => {
                                    resolve(response.data);
                                })
                                .catch(err => {
                                    this.$swal.showValidationMessage(err.response.data);
                                    this.$swal.hideLoading();
                                })
                            } else {
                                resolve();
                            }
                        });
                    },
                    allowOutsideClick: () => !this.$swal.isLoading(),
                    didOpen: () => {
                        if (type === 'phone') {
                            const input = document.querySelector("#change_phone_email_field");
                            input.addEventListener('input', () => {
                                if (input.value.length > 14) input.value = input.value.slice(0, 14);
                            });
                            input.addEventListener('keypress', () => {
                                let phoneNum = input.value.replace(
                                    /[^0-9]/g,
                                    ""
                                );

                                const part1 =
                                    phoneNum.length > 2
                                        ? `(${phoneNum.substring(0, 3)})`
                                        : phoneNum;
                                const part2 =
                                    phoneNum.length > 3 ? ` ${phoneNum.substring(3, 6)}` : "";
                                const part3 =
                                    phoneNum.length > 6 ? `-${phoneNum.substring(6, 10)}` : "";

                                input.value = `${part1}${part2}${part3}`;
                            });
                        }
                    },
                    willClose: () => {
                        if (type === 'phone') {
                            const input = document.querySelector("#change_phone_email_field");
                            input.removeEventListener('input', () => {
                                if (input.value.length > 14) input.value = input.value.slice(0, 14);
                            });
                            input.removeEventListener('keypress', () => {
                                let phoneNum = input.value.replace(
                                    /[^0-9]/g,
                                    ""
                                );

                                const part1 =
                                    phoneNum.length > 2
                                        ? `(${phoneNum.substring(0, 3)})`
                                        : phoneNum;
                                const part2 =
                                    phoneNum.length > 3 ? ` ${phoneNum.substring(3, 6)}` : "";
                                const part3 =
                                    phoneNum.length > 6 ? `-${phoneNum.substring(6, 10)}` : "";

                                input.value = `${part1}${part2}${part3}`;
                            });
                        }
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        if(type === 'email') {
                            this.submitOtpPhoneOrEmail(type, 'change', result.value.message)
                        } else {
                            const user_phone = this.userDetails.phone;
                            const new_phone_email = this.newPhoneEmail;
                            let html = '';
                            let title = '';
                            html = "Are you sure you want to change the Phone Number from <strong>" + user_phone + "</strong> to <strong>" + new_phone_email + "</strong>?";
                            title = "Change Phone Number";
                            if (user_phone == null) {
                                html = "Are you sure you want to add the Phone Number <strong>" + new_phone_email + "</strong>?";
                                title = "Add Phone Number";
                            }
                            this.$swal.fire({
                                title: title,
                                html: html,
                                showCancelButton: true,
                                confirmButtonText: "Confirm",
                                showLoaderOnConfirm: true,
                                confirmButtonColor: "#149bb1",
                                width: '55em',
                                customClass: {
                                    content: 'swal_content_small'
                                },
                                preConfirm: () => {
                                    return new Promise((resolve) => {
                                        if (new_phone_email.trim()) {
                                            const data = {
                                                phone: {
                                                    route: route('change_phone'),
                                                    value: {
                                                        phone: new_phone_email
                                                    }
                                                }
                                            };
                                            axios.post(data[type].route, data[type].value, {})
                                                .then(response => {
                                                    Inertia.reload()
                                                    resolve(response.data);
                                                })
                                                .catch(err => {
                                                    this.$swal.showValidationMessage(err.response.data);
                                                    this.$swal.hideLoading();
                                                });
                                        }
                                    });
                                },
                                allowOutsideClick: () => !this.$swal.isLoading()
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    $(".page_loader").hide(); 
                                    this.$swal.fire({
                                        title: result.value,
                                        icon: `success`,
                                        showConfirmButton: true,
                                        confirmButtonText: "OK",
                                        allowOutsideClick: () => false
                                    }).then((result) => {
                                        if(result.isConfirmed) {
                                            this.newPhoneEmail = null;
                                        }
                                    });
                                }
                            });
                        }
                    }
                });
            },
            submitOtpPhoneOrEmail(type, operationType, status = null) {
                let text = '';
                if (status !== null && status !== 'otp_sent') {
                    text = `<div style="color:#428c01" class="send_otp_msg mb-2">${status}</div>`;
                }
                else if(status === "otp_sent"){
                    text = '<div style="color:#428c01" class="send_otp_msg mb-2">OTP Sent!</div>';
                }
                let timerInterval;

                this.$swal({
                    title: 'Enter OTP',
                    html: text +
                        '<div class="form-group mb-4">' +
                        '<input type="text" id="entered_otp" name="entered_otp" class="form-control swal2-input" placeholder="Enter OTP">' +
                        '<div class="swal_submit_otp text-danger" style="text-align: left; margin-top: -13px; margin-bottom: -19px;"></div>' +
                        '</div>' +
                        `${operationType == 'verify' ?
                            '<div id="resend_msg" class="mb-2 mt-5"></div>' +
                            '<div style="display:none;" id="resend_otp_div"><button type="button" class="btn btn-link" id="resend_otp_btn">Resend OTP</button></div>' : ''}`,
                    showCancelButton: true,
                    confirmButtonText: 'Submit',
                    confirmButtonColor: 'rgb(20, 155, 177)',
                    showLoaderOnConfirm: () => !this.$swal.isLoading(),
                    didOpen: () => {
                        let timer = 30;
                        const enteredOtp = document.querySelector('#entered_otp');
                        enteredOtp.addEventListener('keyup', () => {
                            $('.swal_submit_otp').html('');
                            this.$swal.resetValidationMessage()
                        })
                        $(".send_otp_msg").fadeOut(5000);
                        if (operationType == 'verify') {
                            const resendBtn = document.querySelector('#resend_otp_btn');
                            resendBtn.addEventListener('click', () => {
                                $('.swal_submit_otp').html('');
                                this.$swal.resetValidationMessage();
                                this.resendOtpPhoneOrEmail(type, operationType);
                            })
                            let msg = "";
                            timerInterval = setInterval(() => {
                                const content = this.$swal.getContent()
                                if (content) {
                                    if (timer > 0) {
                                        if (timer > 10) {
                                            $('#resend_msg').css('color', '#428c01');
                                        } else {
                                            $('#resend_msg').css('color', '#dc3545');
                                        }
                                        msg = "Resend OTP in <b>" + timer + "</b> seconds."
                                        if (timer == 1) {
                                            msg = "Resend OTP in <b>" + timer + "</b> second."
                                        }
                                        $("#resend_msg").html(msg);
                                        timer--;
                                    } else {
                                        $("#resend_msg").fadeOut(500);
                                        $("#resend_otp_div").fadeIn(500);
                                        this.$swal.resetValidationMessage();
                                        if ($("#entered_otp").val().trim() == "") {
                                            $('.swal_submit_otp').html('');
                                        }
                                        clearInterval(timerInterval);
                                    }
                                }
                            }, 1000)
                        }
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
                    },
                    preConfirm: () => {
                        return new Promise((resolve) => {
                            const number = $("#entered_otp").val().trim();
                            let error = false;
                            if (number == '') {
                                this.$swal.showValidationMessage("Please enter the OTP!")
                                error = true;
                            }
                            else if (number < 100000 || number > 999999 || !number.match(/(\d){6}/g)) {
                                this.$swal.showValidationMessage("Wrong OTP!")
                                error = true;
                            }
                            if (!error) {
                                const module = {
                                    email: {
                                        value: operationType == 'verify' ? 'email_verify' : 'email_change'
                                    },
                                    phone: {
                                        value: operationType == 'verify' ? 'phone_verify' : 'phone_change'
                                    }
                                }
                                const data = {
                                    mode: type,
                                    module: module[type].value,
                                    otp: number
                                }
                                axios.post(route('confirm-all-otp'), data, {})
                                .then(response => {
                                    resolve(response.data);
                                })
                                .catch(err => {
                                    this.$swal.showValidationMessage(err.response.data);
                                    this.$swal.hideLoading();
                                })
                            }
                            else {
                                resolve();
                            }
                        });
                    },
                    allowOutsideClick: () => !this.$swal.isLoading(),
                })
                .then((result) =>{
                    if (result.isConfirmed) {
                        if (operationType == 'verify') {
                            axios.post(type == 'email' ? route('tp-profile-verify-email') : route('tp-profile-verify-phone'), { otp_id: result.value.otp_id }, {})
                            .then(response => {
                                Inertia.reload()
                                this.$swal.fire({
                                    icon: 'success',
                                    title: response.data,
                                    allowOutsideClick: () => false
                                });
                            })
                            .catch(err => {
                                this.$swal.showValidationMessage(err.response.data);
                            });
                        } else if (operationType == 'change') {
                            const user_email = this.userDetails.email;
                            const user_phone = this.userDetails.phone;
                            const new_phone_email = this.newPhoneEmail;
                            let html = '';
                            let title = '';
                            if (type == 'email') {
                                html = "Are you sure you want to change the Email from <strong>" + user_email + "</strong> to <strong>" + new_phone_email + "</strong>?";
                                title = "Change Email";
                                if (user_email == null) {
                                    html = "Are you sure you want to add the Email <strong>" + new_phone_email + "</strong>?";
                                    title = "Add Email";
                                }
                            } else {
                                html = "Are you sure you want to change the Phone Number from <strong>" + user_phone + "</strong> to <strong>" + new_phone_email + "</strong>?";
                                title = "Change Phone Number";
                                if (user_phone == null) {
                                    html = "Are you sure you want to add the Phone Number <strong>" + new_phone_email + "</strong>?";
                                    title = "Add Phone Number";
                                }
                            }
                            this.$swal.fire({
                                title: title,
                                html: html,
                                showCancelButton: true,
                                confirmButtonText: "Confirm",
                                showLoaderOnConfirm: true,
                                confirmButtonColor: "#149bb1",
                                width: '55em',
                                customClass: {
                                    content: 'swal_content_small'
                                },
                                preConfirm: () => {
                                    return new Promise((resolve) => {
                                        if (new_phone_email.trim()) {
                                            const data = {
                                                email: {
                                                    route: route('change_email'),
                                                    value: {
                                                        email: new_phone_email
                                                    }
                                                },
                                                phone: {
                                                    route: route('change_phone'),
                                                    value: {
                                                        phone: new_phone_email
                                                    }
                                                }
                                            };
                                            axios.post(data[type].route, data[type].value, {})
                                                .then(response => {
                                                    Inertia.reload()
                                                    resolve(response.data);
                                                })
                                                .catch(err => {
                                                    this.$swal.showValidationMessage(err.response.data);
                                                    this.$swal.hideLoading();
                                                });
                                        }
                                    });
                                },
                                allowOutsideClick: () => !this.$swal.isLoading()
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    $(".page_loader").hide(); 
                                    this.$swal.fire({
                                        title: result.value,
                                        icon: `success`,
                                        showConfirmButton: true,
                                        confirmButtonText: "OK",
                                        allowOutsideClick: () => false
                                    }).then((result) => {
                                        if(result.isConfirmed) {
                                            this.newPhoneEmail = null;
                                        }
                                    });
                                }
                            });
                        }
                    }
                });
            },
            resendOtpPhoneOrEmail(type, operationType) {
                const content = {
                    email: {
                        route: route('email-verify-send-otp')
                    },
                    phone: {
                        route: route('send-otp')
                    }
                }
                axios.get(content[type].route, {})
                .then(response => {
                    Inertia.reload();
                    this.submitOtpPhoneOrEmail(type, operationType, 'otp_sent');
                })
                .catch(err => {
                    this.$swal.showValidationMessage('Something went wrong!');
                })
            },
        }
  	}
</script>
<template>
    <div class="card">
        <div class="card-title p-3 pt-2 mb-0" style="margin-bottom: -30px !important;">Personal Information</div>
        <div class="card-body">
            <div class="row">
                <div class="col-12 p-2 form-group">
                    <FormInput 
                        title="Full Name" 
                        v-model='formData.name' 
                        :required="true" 
                        :error="errors.name" 
                        type="text" 
                        name="name" 
                    />
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 p-2 form-group">
                    <label>
                        Email
                    </label>
                    <div class="input-group">
                        <input 
                            type="text"
                            v-model="userDetails.email"
                            class="form-control"
                            placeholder="Email"
                            :class="{'is-invalid': emailError}"
                            disabled
                        />
                        <button v-if="userDetails.email != null && userDetails.email.length && !userDetails.email_verified" class="btn btn-warning" @click="verifyPhoneOrEmail('email')" type="button">Verify</button>
                        <button v-if="userDetails.email != null && userDetails.email.length" @click="changePhoneOrEmail('email')" class="btn btn-info" type="button">
                            Change
                        </button>
                        <button v-else @click="changePhoneOrEmail('email')" class="btn btn-info" type="button">
                            Add
                        </button>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 p-2 form-group">
                    <label>
                        Phone
                    </label>
                    <div class="input-group">
                        <div class="input-group-text">+1</div>
                        <input 
                            type="text"
                            v-model="userDetails.phone"
                            class="form-control"
                            placeholder="Phone"
                            :class="{'is-invalid': emailError}"
                            disabled
                        />
                        <!-- <button v-if="userDetails.phone != null && userDetails.phone.length && !userDetails.phone_verified" @click="verifyPhoneOrEmail('phone')" class="btn btn-warning" type="button">Verify</button> -->
                        <button v-if="userDetails.phone != null && userDetails.phone.length" @click="changePhoneOrEmail('phone')" class="btn btn-info" type="button">
                            Change
                        </button>
                        <button v-else @click="changePhoneOrEmail('phone')" class="btn btn-info" type="button">
                            Add
                        </button>
                    </div>
                </div>
                <div class="col-12 p-2 form-group">
                    <label>
                        Select Time Zone
                        <span class="text-danger">*</span>
                    </label>
                    <MultiSelect 
                        v-model="formData.timezone"
                        :options="timeZoneList"
                        placeholder="Type & select Time Zone" 
                        :custom-label="timezoneOptionLabel" 
                        track-by="text"
                        @select="selectTimezone"
                        @remove="removeSelectedTimezone"
                    >
                    </MultiSelect>
                </div>
            </div>
        </div>
    </div>
</template>